import React, { Component } from 'react'

export default class WorksUomoAlMuro extends Component {
  render() {
    return (
 <div class="modal" id="worksuomoalmuro" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
        <div class="modal-content">
            <div class="modal-header">
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                <h5 class="modal-title"><strong>&quot;L'uomo al muro. Fenoglio e la guerra nei ventitre giorni della città di alba&quot; </strong>(monografia): <em>Italic-peQuod , 2016.</em></h5>
               
            </div>
            <div class="modal-body p-4" id="result">
                   

            <div align="left">

<table border="0"  cellpadding="20">
  <tr colspan="1" width="100%">
  </tr>
  <tr width="100%">

    <td width="50%">


<br/> <br/>

        

          

        A oltre cinquant&rsquo;anni dalla sua scomparsa, Beppe Fenoglio (Alba 1922 &ndash; Torino 1963) ha ottenuto piena consacrazione e viene reputato un classico del nostro Novecento.
<br/><br/>
        Ma non &egrave; stato sempre cos&igrave;. Un quadro ben diverso prese
        forma nel 1952 intorno alla pubblicazione del suo primo libro, I ventitre giorni della citt&agrave; di Alba, accompagnata da incomprensioni ed equivoci, oltrech&eacute; dai feroci attacchi di una parte della critica, ostile per motivi ideologici alla
        rappresentazione che Fenoglio dava della Resistenza. Questi nodi problematici sarebbero perdurati fino a diventare costitutivi della figura dell&rsquo;autore, condizionando lo sviluppo della sua opera come anche la valutazione a cui essa sarebbe
        stata sottoposta.
<br/><br/>
        Uno dei principali intenti del presente testo consiste proprio nel rilevare la ricaduta negativa che l&rsquo;accidentata fase dell&rsquo;esordio ha avuto sull&rsquo;attivit&agrave; di Fenoglio, e quanto egli ne sia stato deviato e
        penalizzato, anche rispetto al suo destino di scrittore postumo.
<br/><br/>
        Larga parte delle sue opere ha visto infatti la luce soltanto dopo la precoce scomparsa, dando il via all&rsquo;estenuante querelle sulla loro datazione che per decenni ha monopolizzato
        l&rsquo;attivit&agrave; critica.
<br/><br/>
        Anche a ci&ograve; si deve che alcune di esse non siano state ancora sottoposte a uno studio mirato e approfondito, come appunto I ventitre giorni della citt&agrave; di Alba, a cui per la prima volta &egrave; qui
        dedicata un&rsquo;intera monografia. Del libro d&rsquo;esordio di Fenoglio viene messo in luce anzitutto l&rsquo;alto valore letterario, sulla base delle qualit&agrave; espresse poi a pieno nelle successive opere.
<br/><br/>
        Se ne ricostruiscono la genesi e il campo della ricezione. Viene quindi trattata la visione della guerra propria dell&rsquo;autore, nella sua assoluta originalit&agrave;, sulla base di una disamina dei racconti legati a questo tema, ripresi infine in rapporto ad alcuni nuclei centrali,
        attraverso rimandi ai libri successivi e la comparazione con quelli di altri autori coevi.
<br/><br/>
        Ne risulta un testo rigoroso e nel contempo chiaro e leggibile a tutti, in uno spirito di servizio nei confronti di Fenoglio e del suo incontro con i sempre
        pi&ugrave; numerosi lettori ed estimatori della sua opera.
      
   



<br/>

<strong>ne hanno scritto:</strong> <br/><br/>

<ul>
<li><a href="rec/uomoalmuro/adige.pdf" target="_blank" >Fabrizio Franchi, l’Adige, 11 febbraio 2016</a></li>
<li>Fausta Slanzi, Trentino e Alto Adige, 19 febbraio 2016</li>
<li>Silvia Pagliuca, Corriere del Trentino, 23 febbraio 2016</li>
<li>Antonio Luccarini, il Messaggero, 16 febbraio 2016</li>
<li><a href="rec/uomoalmuro/avvenire.pdf" target="_blank" >Massimo Raffaeli, Avvenire, 1 marzo 2016</a></li>
<li><a href="rec/uomoalmuro/repubblica.pdf" target="_blank" >Paolo Mauri, il Venerdì di Repubblica, 25 marzo 2016</a></li>
<li>Fausta Slanzi, Trentino, 30 agosto 2016</li>
<li>Intervista a Fahrenheit, radio 3, 17 febbraio 2016</li>
<li><a href="rec/uomoalmuro/italianistica_tamburini.pdf" target="_blank" >Carlo Zanantoni, Italianistica, Rivista di letteratura. Anno XLVI n. 2 maggio – agosto 2017</a></li>

</ul>







</td >


</tr>
</table>
</div>















            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
        </div>
    </div>
</div>


    )
  }
}
